<!-- 
  详情页 - 工单备件信息
  props:
    id: 详情id
 -->

<template>
  <div class="v-tabs product-list">
    <div class="head">
      <div class="total">
        {{tableData.length}}种产品{{totalProducts}}件
      </div>
    </div>
    <div class="content">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="name" label="产品名称" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="productNo" label="产品编号" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="specification" label="规格" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="price" label="单价（元）" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="unit" label="单位" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="num" label="数量" show-overflow-tooltip>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import * as api from 'src/api'

export default {
  created () {
    this.getList()
  },
  props: {
    id: {
      type: Number
    }
  },
  data () {
    return {
      tableData: []
    }
  },
  computed: {
    totalProducts () {
      let i = 0
      this.tableData.forEach(item => {
        // i += item.num
        i = utils.plus(i, item.num)
      })
      return i
    }
  },
  methods: {
    getList () {
      let url = '/workOrder/getProduct.html'
      let params = {
        id: this.id
      }
      api.post(url, params, (data) => {
        this.tableData = data.result
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// product-list.vue?4e0dd31b